export const coerceToPercent = (value: number | undefined, decimalPlaces: number) => {
  if (!value) {
    return undefined;
  }
  return (value * 100).toFixed(decimalPlaces);
};
